<template>
	<div
		class="g-block-title-center-rail g-block-title-padding"
		:class="{
			'g-block-title-center-rail--edit': editable,
			'is-active': editable && active,
			'g-block-title-center-rail--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-center-rail__box">
			<span class="g-block-title-center-rail__rail" :style="{ background: lightColor }"></span>
			<div class="g-block-title-center-rail__wrap">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-center-rail__text"
					fit-content
					:style="{ color: themeColor }"
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-center-rail__text"
					:style="{ color: themeColor }"
					v-html="data.content || ''"
				></div>
				<span class="g-block-title-center-rail__accent" :style="{ background: themeColor }"></span>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleCenterRail',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-center-rail {
		.title-block-edit-shell();
	}

	.g-block-title-center-rail__box {
		position: relative;
		display: flex;
		justify-content: center;
	}

	.g-block-title-center-rail__rail {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 1px;
		height: 1px;
		z-index: 0;
	}

	.g-block-title-center-rail__wrap {
		position: relative;
		z-index: 1;
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		max-width: 100%;
	}

	.g-block-title-center-rail__text {
		padding: 0 12px;
		background: #fff;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		text-align: center;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-center-rail__accent {
		display: block;
		width: calc(100% + 24px);
		height: 3px;
		margin-top: 8px;
		flex-shrink: 0;
	}

	.g-block-title-center-rail--h5 {
		.g-block-title-center-rail__text { font-size: 0.44rem; padding: 0 0.24rem; }
		.g-block-title-center-rail__rail { bottom: 0.03rem; height: 0.02rem; }
		.g-block-title-center-rail__accent { width: calc(100% + 0.48rem); height: 0.06rem; margin-top: 0.16rem; }
	}
</style>
